import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import WarningIcon from '@material-ui/icons/Warning'
import React, { FC } from 'react'

import { useStyles } from './BulkActivateDeactivateDialog.styles'
import { SelectedListing } from './BulkActivateDeactivateDialog.types'

type FailureContentProps = {
    eligible: SelectedListing[]
    failedNames: string[]
    target: string
}

export const FailureContent: FC<FailureContentProps> = ({ eligible, failedNames, target }) => {
    const classes = useStyles()
    return (
        <>
            <Typography variant="body2">
                <strong>
                    {failedNames.length} of {eligible.length}
                </strong>{' '}
                product{failedNames.length === 1 ? '' : 's'} could not be updated.{' '}
                The remaining {eligible.length - failedNames.length}{' '}
                {eligible.length - failedNames.length === 1 ? 'was' : 'were'} set to{' '}
                <strong>{target}</strong>.
            </Typography>
            <div role="alert" className={classes.errorBox}>
                <WarningIcon fontSize="small" />
                Retry, or open each item to resolve the conflict.
            </div>
            <ul className={classes.listContainer}>
                {eligible.map((p) => {
                    const failed = failedNames.includes(p.productName)
                    return (
                        <li
                            key={p.listingId}
                            className={`${classes.listRow} ${failed ? classes.listRowFail : ''}`}
                        >
                            <span>{p.productName}</span>
                            <span
                                className={`${classes.statusBadge} ${failed ? classes.statusFail : classes.statusSuccess}`}
                            >
                                {failed ? 'Failed' : 'Updated'}
                            </span>
                        </li>
                    )
                })}
            </ul>
        </>
    )
}

type FailureActionsProps = {
    onClose: () => void
    onRetry: () => void
    failedNames: string[]
}

export const FailureActions: FC<FailureActionsProps> = ({ onClose, onRetry, failedNames }) => {
    const classes = useStyles()
    return (
        <>
            <Button onClick={onClose} variant="text" className={classes.cancelButton}>
                Close
            </Button>
            <Button onClick={onRetry} variant="contained" color="primary" data-testid="btnRetryFailed">
                Retry failed ({failedNames.length})
            </Button>
        </>
    )
}
